// What a name dialog refuses (`RenameDialog`), as plain words — so an
// agent's save is held to the same rule as the dialog's Save button.

export const NAME_MAX_LENGTH = 100;

/**
 * Why `name` cannot be saved, or null: empty once trimmed, the name it
 * already has when a change is required, or too long.
 */
export function nameProblem(name, { currentName, requireChange = false } = {}) {
  const trimmed = String(name ?? '').trim();
  if (!trimmed) return 'Name cannot be empty';
  if (requireChange && trimmed === currentName)
    return 'Please enter a different name';
  if (trimmed.length > NAME_MAX_LENGTH)
    return 'Name must be less than 100 characters';
  return null;
}
